import axios from './axios';
import axiosFileDownloader from './axiosFileDownloader';
import axiosFileUploader from './axiosFileUploader';

class SparePartService {

    static Instance() {
        return new SparePartService();
    }

    // spare parts
    saveSparePart(req) {
        return axios.post('api/spareparts/save', req);
    }

    getSparePart(prodCode) {
        return axios.get('api/spareparts/' + prodCode);
    }

    listSpareParts(req) {
        return axios.post('api/spareparts/list', req);
    }

    deleteSparePart(prodCode) {
        return axios.post('api/spareparts/delete/' + prodCode);
    }

    saveAttachment(formData) {
        return axiosFileUploader.post('api/spareparts/attachment/save', formData);
    }

    // groups
    getGroup(id) {
        return axios.get('api/spareparts/groups/' + id);
    }

    listGroups(req) {
        return axios.post('api/spareparts/groups', req);
    }

    saveGroup(req) {
        return axios.post('api/spareparts/groups/save', req);
    }

    deleteGroup(id) {
        return axios.post('api/spareparts/groups/delete/' + id);
    }

    // subgroups
    getSubGroup(id) {
        return axios.get('api/spareparts/subgroups/' + id);
    }

    listSubGroups(req) {
        return axios.post('api/spareparts/subgroups/', req);
    }

    saveSubGroup(req) {
        return axios.post('api/spareparts/subgroups/save', req);
    }

    deleteSubGroup(id) {
        return axios.post('api/spareparts/subgroups/delete/' + id);
    }
}

export default SparePartService;